<div class="login-container">
  <div class="login-card">

    <img src="assets/img/gma_tipografia.png" alt="GMA" class="login-logo" />
    <p class="login-subtitle">Solicitar cadastro</p>

    @if (!cadastroEnviado) {
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="container-form">
        <div class="field">
          <p-floatlabel variant="on">
            <input pInputText id="login" formControlName="login" [class.ng-invalid]="isInvalid('login')"
              [class.ng-dirty]="isInvalid('login')" />
              <label for="login">Login</label>
            </p-floatlabel>
            @if (isInvalid('login')) {
              <small class="field-error">Login obrigatório</small>
            }
          </div>
          <div class="field">
            <p-floatlabel variant="on">
              <input pInputText id="email" type="email" formControlName="email" [class.ng-invalid]="isInvalid('email')"
                [class.ng-dirty]="isInvalid('email')" />
                <label for="email">E-mail</label>
              </p-floatlabel>
              @if (form.get('email')?.touched && form.get('email')?.hasError('required')) {
                <small class="field-error">E-mail obrigatório</small>
              }
              @if (form.get('email')?.touched && form.get('email')?.hasError('email')) {
                <small class="field-error">E-mail inválido</small>
              }
            </div>
            <div class="field">
              <p-floatlabel variant="on">
                <input pInputText id="senha" type="password" formControlName="senha" [class.ng-invalid]="isInvalid('senha')"
                  [class.ng-dirty]="isInvalid('senha')" />
                  <label for="senha">Senha</label>
                </p-floatlabel>
                @if (isInvalid('senha')) {
                  <small class="field-error">Senha obrigatória</small>
                }
              </div>
              <div class="field">
                <p-floatlabel variant="on">
                  <input pInputText id="confirmacaoSenha" type="password" formControlName="confirmacaoSenha"
                    [class.ng-invalid]="isInvalid('confirmacaoSenha') || senhasNaoConferem"
                    [class.ng-dirty]="isInvalid('confirmacaoSenha') || senhasNaoConferem" />
                    <label for="confirmacaoSenha">Confirmar senha</label>
                  </p-floatlabel>
                  @if (isInvalid('confirmacaoSenha')) {
                    <small class="field-error">Confirmação de senha obrigatória</small>
                  }
                  @if (senhasNaoConferem) {
                    <small class="field-error">As senhas não conferem</small>
                  }
                </div>
                @if (erroConflito) {
                  <div class="login-error">
                    Este login já está em uso. Tente outro.
                  </div>
                }
                @if (erroGenerico) {
                  <div class="login-error">
                    Erro ao enviar solicitação. Tente novamente.
                  </div>
                }
                <div>
                  <p-button type="submit" label="Solicitar cadastro" styleClass="w-full" [loading]="loading" />
                </div>
              </form>
              <div class="register-request">
                <span>Já tem uma conta?</span>
                <a [routerLink]="['/login']" class="register-link">Entrar</a>
              </div>
            } @else {
              <div class="aprovacao-msg">
                <i class="pi pi-check-circle aprovacao-icon"></i>
                <p>Solicitação enviada com sucesso!</p>
                <p>Aguarde a aprovação do administrador para acessar o sistema.</p>
              </div>
              <div class="register-request">
                <a [routerLink]="['/login']" class="register-link">Voltar ao login</a>
              </div>
            }


          </div>
        </div>